export default [
  {
    path: '/receivables/agreements',
    name: 'AgreementList',
    component: () => import(/* webpackChunkName: "receivables" */ '@/views/receivables/AgreementList.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'PaymentListCreate',
      requireAuth: true,
      requireAccount: true,
      requireRevenue: true,
      title: 'Acuerdos'
    }
  }
]
